export interface PATH_VALIDATE_TYPE {
  [key: string]: {
    validateChildPath: string[];
  };
}

export const HyosungDisabledDates = [
  { startDate: '2024-12-13 23:30:00', endDate: '2024-12-14 07:00:00', endTimeStr: '오전 07시' },
];

export const CDN = 'https://l0xlmyrl8323.edge.naverncp.com';

export const CDN_LONGVOCA = process.env.REACT_APP_NODE_ENV == 'production' ? `${CDN}/longvoca` : `${CDN}/longvoca-dev`;

export const STUDENT_LONGVOCA_URL =
  process.env.REACT_APP_NODE_ENV === 'production'
    ? 'https://student.longedu.co.kr'
    : 'https://longstudent.irontrain.co.kr';

//** 문법학습 모드 **//
export const GRAMMAR_MODES = ['grammar_t', 'grammar_b', 'grammar_d'];

//** 문법학습 모드 > 이론 학습 모듈 **//
export const THEORY_LABEL: { [key: number]: string } = {
  1: '이론영상',
  2: '단어점검',
  3: '이론점검',
};

export const EMPTY_BANNER: BannerType = {
  enddate: '2040-02-15 23:59:59',
  height: '96',
  href: '',
  id: 'defaul',
  modifydate: '2023-01-01 00:00:00',
  path: `longvoca_banner.png`,
  postdate: '2023-01-01 00:00:00',
  priority: '999',
  short_path: `longvoca_banner.png`,
  startdate: '2023-01-01 00:00:00',
  status: '진행 중',
  target: '_blank',
  title: 'ready',
  ver: '2',
  width: '499',
};

export const PERSONAL_PRODUCT_CODES = ['A003Y', 'A003H', 'A003N', 'S003Y', 'S003H', 'S003M', 'V003Y', 'V003H', 'V003M'];
export const P_SPEAK_PRODUCT_CODES = ['S003Y', 'S003H', 'S003M', 'S003DY', 'S003TY'];

export const MESSAGE_CHARGE_ITEMS: ChoiceDataType[] = [
  {
    id: 1,
    product: 'm1',
    price: '50,000',
    message: '5,000',
    title: '메시지 5,000건',
    sub_title: '(카카오톡 알림톡 건당 10원, <span style="color: black;">￦ 50,000원</span>)',
  },
  {
    id: 2,
    product: 'm2',
    price: '100,000',
    message: '11,000',
    title: '메시지 11,000건',
    sub_title:
      '(카카오톡 알림톡 건당 10원 <span style="color: red;">+ 1,000건 추가 적립</span>, <span style="color: black;">￦ 100,000원</span>)',
  },
];

export const SEND_MESSAGE_COMMENT_KEY = [
  'dailyReport_single',
  'dailyReport_multi',
  'periodReport_single',
  'periodReport_multi',
  'leaderboard',
];

export const SEND_MULTI_MESSAGE_KEY = ['notice', 'dailyReport_multi', 'periodReport_multi'];

export const DIST_BOOK_REGEX = /_빈출단어 모음(?: - (\d+))?/;

export const DIRECT_INPUT_ID_REGEX = /direct_/gi;
export const LINE_BREAKS_REGEX = /\r\n|\n/g;
export const SPACE_REGEX = /\s+/g;
export const KOREAN_REGEX = /[ㄱ-ㅎㅏ-ㅣ가-힣]/;

export const CHAR_REGEX = /[^a-zA-Z0-9ㄱ-힣]/g;
export const PHONE_REGEX = /^01([0|1|6|7|8|9])-?([0-9]{3,4})-?([0-9]{4})$/;
export const PASSWORD_REGEX =
  /^(((?=.*[a-z])(?=.*[!@#$%&*_+]))|((?=.*[!@#$%&*_+])(?=.*[0-9]))|((?=.*[a-z])(?=.*[0-9])))(?!.*[A-Zㄱ-힣])(\S){8,20}$/;

export const IMAGE_DATA_BASE_64 = '';
// process.env.REACT_APP_LOCAL === 'false' || process.env.REACT_APP_NODE_ENV === 'development'
//   ? ''
//   : 'data:image/png;base64,';

export const PERSONAL_PRODUCT_PRICES: { [key: string]: { [key: string]: number } } = {
  A: {
    '003Y': 289000,
    '003H': 184000,
    '003M': 59000,
  },
  S: {
    '003Y': 159000,
    '003H': 116000,
    '003M': 26000,
  },
  V: {
    '003Y': 189000,
    '003H': 138000,
    '003M': 31000,
  },
  G: {
    '003Y': 209000,
    '003H': 149000,
    '003M': 33000,
  },
};

export const CARD_PATH_VALIDATE: PATH_VALIDATE_TYPE = {
  student: {
    validateChildPath: ['', 'teacher', 'list', 'listexcel'],
  },
  lesson: {
    validateChildPath: ['booklist'],
  },
  quiz: {
    validateChildPath: [],
  },
  test: {
    validateChildPath: ['testlist'],
  },
  score: {
    validateChildPath: [],
  },
  setting: {
    validateChildPath: ['', 'noticement', 'paymentview', 'admininfo'],
  },
};

export const SUBTITLE_PATH_VALIDATE: PATH_VALIDATE_TYPE = {
  student: {
    validateChildPath: ['', 'teacher', 'class', 'list', 'listexcel', 'assignclass'],
  },
  lesson: {
    validateChildPath: ['', 'bookmaking', 'booklist', 'classsettings'],
  },
  quiz: {
    validateChildPath: [],
  },
  test: {
    validateChildPath: ['testlist'],
  },
  score: {
    validateChildPath: [],
  },
  setting: {
    validateChildPath: ['manual', 'admininfo'],
  },
};

export const EXCEPT_TEACHER_PATH: PATH_VALIDATE_TYPE = {
  student: {
    validateChildPath: [],
  },
  lesson: {
    validateChildPath: ['classsettings'],
  },
  quiz: {
    validateChildPath: [],
  },
  test: {
    validateChildPath: [],
  },
  score: {
    validateChildPath: [],
  },
  setting: {
    validateChildPath: ['paymentview'],
  },
};

export const EXCEPT_PERSONAL_ADMIN_PATH: PATH_VALIDATE_TYPE = {
  student: {
    validateChildPath: ['listexcel'],
  },
  lesson: {
    validateChildPath: [],
  },
  quiz: {
    validateChildPath: [],
  },
  test: {
    validateChildPath: [],
  },
  score: {
    validateChildPath: [],
  },
  setting: {
    validateChildPath: [],
  },
};

export const EXCEPT_PERSONAL_TEACHER_PATH: PATH_VALIDATE_TYPE = {
  student: {
    validateChildPath: ['listexcel'],
  },
  lesson: {
    validateChildPath: ['classsettings'],
  },
  quiz: {
    validateChildPath: [],
  },
  test: {
    validateChildPath: [],
  },
  score: {
    validateChildPath: [],
  },
  setting: {
    validateChildPath: ['paymentview'],
  },
};

export const NOT_USE_TAB = -1;

export const RANKING_ARRAY = [1, 2, 3];
export const TEMP_STDUENT_IDS = [1, 2, 3, 4, 5];

export const TEACHER_PERMISSION_LIST = [
  { id: 2, name: '부원장' },
  { id: 3, name: '실장' },
  { id: 4, name: '선생님' },
  { id: 5, name: '기타' },
];

export const CLASS_START_TIME_LIST = [
  { id: 1, name: '9시 00분' },
  { id: 2, name: '9시 30분' },
  { id: 3, name: '10시 00분' },
  { id: 4, name: '10시 30분' },
  { id: 5, name: '11시 00분' },
  { id: 6, name: '11시 30분' },
  { id: 7, name: '12시 00분' },
  { id: 8, name: '12시 30분' },
  { id: 9, name: '13시 00분' },
  { id: 10, name: '13시 30분' },
  { id: 11, name: '14시 00분' },
  { id: 12, name: '14시 30분' },
  { id: 13, name: '15시 00분' },
  { id: 14, name: '15시 30분' },
  { id: 15, name: '16시 00분' },
  { id: 16, name: '16시 30분' },
  { id: 17, name: '17시 00분' },
  { id: 18, name: '17시 30분' },
  { id: 19, name: '18시 00분' },
  { id: 20, name: '18시 30분' },
  { id: 21, name: '19시 00분' },
  { id: 22, name: '19시 30분' },
  { id: 23, name: '20시 00분' },
  { id: 24, name: '20시 30분' },
  { id: 25, name: '21시 00분' },
  { id: 26, name: '21시 30분' },
  { id: 27, name: '22시 00분' },
  { id: 28, name: '22시 30분' },
  { id: 29, name: '23시 00분' },
  { id: 30, name: '23시 30분' },
  { id: 31, name: '00시 00분' },
];

export const CLASS_QUESTION_TIME_LIMIT_LIST = [
  { id: 1, name: '3초' },
  { id: 2, name: '5초' },
  { id: 3, name: '10초' },
  { id: 4, name: '20초' },
];

export const STUDENT_GRADE_LIST = [
  { id: 'e1', name: '초등학교 1학년' },
  { id: 'e2', name: '초등학교 2학년' },
  { id: 'e3', name: '초등학교 3학년' },
  { id: 'e4', name: '초등학교 4학년' },
  { id: 'e5', name: '초등학교 5학년' },
  { id: 'e6', name: '초등학교 6학년' },
  { id: 'm1', name: '중학교 1학년' },
  { id: 'm2', name: '중학교 2학년' },
  { id: 'm3', name: '중학교 3학년' },
  { id: 'h1', name: '고등학교 1학년' },
  { id: 'h2', name: '고등학교 2학년' },
  { id: 'h3', name: '고등학교 3학년' },
  { id: 'etc', name: '기타' },
];

export const STUDENT_GRADE_LIST_DROPDOWN = [
  { id: 'all', content: '전체' },
  { id: 'a1', content: '초 1' },
  { id: 'a2', content: '초 2' },
  { id: 'a3', content: '초 3' },
  { id: 'a4', content: '초 4' },
  { id: 'a5', content: '초 5' },
  { id: 'a6', content: '초 6' },
  { id: 'b1', content: '중 1' },
  { id: 'b2', content: '중 2' },
  { id: 'b3', content: '중 3' },
  { id: 'c1', content: '고 1' },
  { id: 'c2', content: '고 2' },
  { id: 'c3', content: '고 3' },
];

export const STUDENT_GRADE_LIST_SORT = [
  { id: 'all', label: '전체' },
  { id: 'a1', label: '초1' },
  { id: 'a2', label: '초2' },
  { id: 'a3', label: '초3' },
  { id: 'a4', label: '초4' },
  { id: 'a5', label: '초5' },
  { id: 'a6', label: '초6' },
  { id: 'b1', label: '중1' },
  { id: 'b2', label: '중2' },
  { id: 'b3', label: '중3' },
  { id: 'c1', label: '고1' },
  { id: 'c2', label: '고2' },
  { id: 'c3', label: '고3' },
];

export const BOOK_SORTING_DROPDOWN = [
  { id: 'abc', content: '가나다순' },
  { id: 'created', content: '최근 제작순' },
];

export const BOOK_EXCEL_DOWNLOAD = [
  { id: 'general', name: '일반 양식' },
  { id: 'unit', name: '유닛별 양식' },
];

export const NOTICE_LIST = [
  { id: 1, name: '전체공지' },
  { id: 2, name: '수업공지' },
  { id: 3, name: '반별공지' },
];

export const CASH_RECEIPTS_TYPE_LIST = [
  { id: 1, name: '소득공제용' },
  { id: 2, name: '지출증빙용' },
];

export const TEST_LEVEL = [
  { id: 1, name: '힌트 없음' },
  { id: 2, name: '주관식 첫글자 표기' },
];

export const TEST_AUTO_SET_QUESTION = [
  { id: 1, name: '수동 출제' },
  { id: 2, name: '자동 출제' },
];

export const TEST_FAILURE_METHOD = [
  { id: 1, name: '틀린 문제만 출제' },
  { id: 2, name: '전체 출제' },
];

export const TEST_SCHEDULE_SETTING = [
  { id: 1, name: '즉시 배포' },
  { id: 2, name: '예약 배포' },
];

export const TEST_NUMVER_DEPLOYMENTS = [
  { id: 1, name: '1회' },
  { id: 2, name: '2회' },
  { id: 3, name: '3회' },
  { id: 4, name: '4회' },
  { id: 5, name: '5회' },
  { id: 6, name: '6회' },
  { id: 7, name: '7회' },
  { id: 8, name: '8회' },
  { id: 9, name: '9회' },
  { id: 10, name: '10회' },
  { id: 11, name: '11회' },
  { id: 12, name: '12회' },
  { id: 13, name: '13회' },
  { id: 14, name: '14회' },
  { id: 15, name: '15회' },
  { id: 16, name: '16회' },
  { id: 17, name: '17회' },
  { id: 18, name: '18회' },
  { id: 19, name: '19회' },
  { id: 20, name: '20회' },
  { id: 21, name: '21회' },
  { id: 22, name: '22회' },
  { id: 23, name: '23회' },
  { id: 24, name: '24회' },
  { id: 25, name: '25회' },
  { id: 26, name: '26회' },
  { id: 27, name: '27회' },
  { id: 28, name: '28회' },
  { id: 29, name: '29회' },
  { id: 30, name: '30회' },
];

export const TEST_DEPLOYMENT_INTERVAL = [
  { id: 1, name: '매일' },
  { id: 2, name: '2일' },
  { id: 3, name: '3일' },
  { id: 4, name: '4일' },
  { id: 5, name: '5일' },
  { id: 6, name: '6일' },
  { id: 7, name: '7일' },
  { id: 8, name: '8일' },
  { id: 9, name: '9일' },
  { id: 10, name: '10일' },
  { id: 11, name: '없음' },
  { id: 12, name: '사용자 설정' },
];

export const ALL_PERSONAL_PRODUCT_PRICES = {
  M: { full: 89000, earlybird: 0, pkg: 0, monthDiscount: 0 },
  H: { full: 534000, earlybird: 160000, pkg: 140000, monthDiscount: 0 },
  Y: { full: 1068000, earlybird: 379000, pkg: 200000, monthDiscount: 200000 },
};

export const SPEAK_PERSONAL_PRODUCT_PRICES = {
  M: { full: 31000, earlybird: 0, pkg: 0, monthDiscount: 0 },
  H: { full: 186000, earlybird: 30000, pkg: 20000, monthDiscount: 0 },
  Y: { full: 372000, earlybird: 120000, pkg: 77000, monthDiscount: 0 },
};

export const VOCA_PERSONAL_PRODUCT_PRICES = {
  M: { full: 38000, earlybird: 0, pkg: 0, monthDiscount: 0 },
  H: { full: 228000, earlybird: 40000, pkg: 30000, monthDiscount: 0 },
  Y: { full: 456000, earlybird: 157000, pkg: 100000, monthDiscount: 0 },
};

export const GRAMMAR_PERSONAL_PRODUCT_PRICES = {
  M: { full: 45000, earlybird: 0, pkg: 0, monthDiscount: 0 },
  H: { full: 270000, earlybird: 60000, pkg: 31000, monthDiscount: 0 },
  Y: { full: 540000, earlybird: 130000, pkg: 101000, monthDiscount: 0 },
};

export const NOTICE_CONTENT_LIMIT = 5000;

export const STUDENT_GRADE_DROPDOWN_CONTENTS = STUDENT_GRADE_LIST.map(item => item.name);

const makeYearArr = () => {
  const year = new Date().getFullYear();
  const year_arr = [];
  for (let i = year; i > 1979; i--) {
    year_arr.push(`${i}년`);
  }
  return year_arr;
};

export const YEAR_DROPDOWN_CONTENTS = makeYearArr();

export const IMPORT_BOOK_TABS = ['오래보카', '초등 교과서', '중등 교과서', '고등 교과서', '모의고사', '수능'];

export const TEACHER_TABLE_DETAIL_OPTIONS = {
  detailStartNum: 2,
  detailFields: { class_name: '담당 클래스', sub_class_name: '부담당 클래스' },
};

export const CLASS_TABLE_DETAIL_OPTIONS = {
  detailStartNum: 2,
  detailFields: { teacher: '담당', sub_teachers: '부담당', student: '학생' },
};

export const STUDENT_TABLE_DETAIL_OPTIONS = {
  detailStartNum: 2,
  detailFields: {
    multi_room: '중복 클래스',
    phone: '연락처',
    school: '학교명',
    birthdate: '생년월일',
    parent_name: '학부모 이름',
    parent_phone: '학부모 연락처',
  },
};

export const STUDY_BOOK_DETAIL_OPTIONS = {
  detailStartNum: 1,
  detailFields: { units: '유닛' },
};

export const NOTICE_TABLE_DETAIL_OPTIONS = {
  detailStartNum: 2,
  detailFields: {
    class_name: '클래스',
    noticeContetnt: '내용',
  },
};

export const UPDATE_NEWS_DETAIL_OPTIONS = {
  detailFields: {
    updateNewsContent: '내용',
  },
};

export const BOOK_TABLE_DETAIL_OPTIONS = {
  detailStartNum: 2,
  detailFields: {
    grade: '학년',
    publisher: '제작자',
    publishdate: '제작년도',
    deployStudents: '배포 인원',
  },
};

export const BOOK_TABLE_DETAIL_OPTIONS_S = {
  detailStartNum: 2,
  detailFields: {
    units: '유닛',
    unitNumbers: '위치',
  },
};

export const DAILY_REPORT_TABLE_DETAIL_OPTIONS = {
  detailStartNum: 4,
  detailFields: {
    basic: '기본학습',
    advanced: '심화학습',
  },
};

export const AWARD_HISTORY_TABLE_DETAIL_OPTIONS = {
  detailStartNum: 3,
  detailFields: {
    award_list: '수상',
  },
};

export const CURRENT_REPORT_TABLE_DETAIL_OPTIONS = {
  detailStartNum: 0,
  detailFields: {
    basic: '기본학습',
    advanced: '심화학습',
  },
};

export const DEFAULT_LOGO = 'https://www.tabstudy.co.kr/admin/img/logo.798666f8.svg';

export const ACCEPT_IMAGE_TYPE = ['image/jpeg', 'image/png'];

export const MODAL_STUDY_SETTING_IMAGE = {
  title: '이미지 학습 방식을 선택해주세요!',
  contents: [],
};

export const image_content_1 = `<h3>
                  연상 학습 (<span>이미지 O</span>)
                </h3>
                <p>학습 간 단어에 알맞는 사진과 함께</p>
                <p>
                  이미지 연상 학습으로 단어를 암기합니다.
                </p>
              </div>`;

export const image_content_2 = `<h3>
                  일반 학습 (<span>이미지 X</span>)
                </h3>
                <p>
                  이미지 없이 철자, 뜻으로만
                </p>
                <p>반복학습을 통해 단어를 암기합니다.</p>`;

export const method_content_1 = `<h3>
                  자율 학습 (<span>학생 스스로 과정 선택</span>)
                </h3>
                <p>
                  모든 학습 과정을 학습할 수 있지만,
                </p>
                <p>
                 강제성 없이 자유롭게 단계 이동이 가능합니다.
                 </p>`;

export const method_content_2 = `<h3>
                  단계별 학습 (<span>관리자가 정해준 과정</span>)
                </h3>
                <p>
                  관리자 모드를 통해 부여된 과정에 의해
                </p>
                <p>
                 강제성 있게 단계적 학습을 부여합니다.
                 </p>`;

export const wrongNote_content_1 = `<h3>
                  자동 생성 (<span>오답단어 자동 학습</span>)
                </h3>
                <p>
                  기본, 심화학습 간 오답 단어 발생 시,
                </p>
                <p>자동으로 오답 학습을 생성합니다.</p>`;

export const wrongNote_content_2 = `<h3>
                  사용 안함 (<span>오답단어 성적 기록만</span>)
                </h3>
                <p>
                  오답 단어가 발생하더라도 레포트에 기록하고
                </p>
                <p>오답 학습을 생성하지 않습니다.</p>`;

export const testMethod_content_1 = `<h3>
                  통합 출제 (<span>테스트 1개 출제</span>)
                </h3>
                <p>
                  선택된 시험 범위에서 단일 테스트를 출제하여
                </p>
                <p>모의평가를 치룹니다.</p>`;
export const testMethod_content_2 = `<h3>
                  개별 출제 (<span>유닛 갯수대로 출제</span>)
                </h3>
                <p>
                  선택된 유닛을 각 시험범위로 설정하고
                </p>
                <p>테스트를 한 번에 개별 생성합니다.</p>`;
export const print_content_1 = `<h3>
                  <span class="highlight">
                    <div>단어 목록</div>
                  </span>
                </h3>
                <p>
                  교재에 수록된 단어 목록을 출력하여
                </p>
                <p><span>암기식 테스트지</span>로 활용합니다.</p>`;
export const print_content_2 = `<h3>
                  <span class="highlight">
                    <div>쓰기 연습</div>
                  </span>
                </h3>
                <p>
                  영어 줄노트가 포함된 목록으로
                </p>
                <p><span>철자 쓰기 연습용</span>으로 활용합니다.</p>`;
export const print_content_3 = `<h3>
                  <span class="highlight">
                   <div>단어 카드</div>
                  </span>
                </h3>
                <p>
                  사전 전용 암기카드 형식으로
                </p>
                <p><span>이미지 연상 학습용</span>으로 활용합니다.</p>`;
export const print_type_content_1 = `<h3>
                    <div style="font-size: 1.3rem;">교재 출력 (<span>유닛별 한 장씩 출력</span>)</div>
                </h3>
                <p>
                  온라인 학습 이후, 직접 출력하시어
                </p>
                <p>워크시트로 이용해보세요!</p>`;
export const print_type_content_2 = `<h3>
                    <div style="font-size: 1.3rem;">시험지 출력 (<span>범위 설정 후 문제출력</span>)</div>
                </h3>
                <p>
                  주간, 월간 해당 기간에 학습된 단어를
                </p>
                <p>시험지로 이용해보세요!</p>`;

export const course_type_content_1 = `<h3>
                    <div style="font-size: 1.3rem;">필수어휘 코스북</div>
                </h3>
                <p style="font-size: 1.1rem; ">
                  초중고 내신 필수어휘와 토익, 입시영어 등
                </p>
                <p style="font-size: 1.1rem; ">수준별 어휘 컨텐츠</p>`;
export const course_type_content_2 = `<h3>
                    <div style="font-size: 1.3rem;">내신대비 컨텐츠</div>
                </h3>
                <p style="font-size: 1.1rem; ">
                  초중고 내신, 모의고사, 수능대비 등
                </p>
                <p style="font-size: 1.1rem; ">학교별 내신 어휘 컨텐츠</p>`;
export const new_print_type_content_1 = `<h3>
                    <div style="font-size: 1.3rem;">필수어휘 코스북</div>
                </h3>
                <p style="font-size: 1rem; margin-bottom : 0.25rem;">
                  초중고 내신 필수어휘와 토익,
                </p>
                <p style="font-size: 1rem; ">입시영어 등 수준별 어휘 컨텐츠</p>`;
export const new_print_type_content_2 = `<h3>
                    <div style="font-size: 1.3rem;">내신대비 컨텐츠</div>
                </h3>
                <p style="font-size: 1rem; margin-bottom : 0.25rem;">
                  학년별 내신, 모의고사, 수능 등
                </p>
                <p style="font-size: 1rem; ">학교별 내신 어휘 컨텐츠</p>`;
export const new_print_type_content_3 = `<h3>
                    <div style="font-size: 1.3rem;">핵심문법 1분 요약</div>
                </h3>
                <p style="font-size: 1rem; margin-bottom : 0.25rem;">
                  초등~중등 내신 필수 영문법
                </p>
                <p style="font-size: 1rem; ">핵심 요약 컨텐츠</p>`;

export const CUT_LINE_SCORE_ARRAY = [0, 5, 10, 15, 20, 25, 30, 35, 40, 45, 50, 55, 60, 65, 70, 75, 80, 85, 90, 95, 100];

export const QUESTION_LIMIT_TIME = [3, 5, 7, 10, 20, 30];

export const FIND_TEXT_FIELD_PLACEHOLDER_LIST: { [key: string]: string } = {
  name: '이름 입력',
  loginid: '아이디 입력',
  phone: '휴대폰 번호 입력',
  cert_num: '인증번호 입력',
};

export const DEFAULT_SELECTED_CLASS: ClassDataResType = {
  id: -1,
  centerId: 0,
  teacher_id: 0,
  name: '',
  count: 0,
  postdate: '',
  study_days: '',
  teacher_name: '',
  study_start_time: '',
  use_push: 0,
  use_rank: 0,
  limit_time: 0,
  sub_teachers: '',
  students: '',
  teacher_account_id: 0,
};

export const REQUIRED_BULK_CREATE_FIELDS = ['class_name', 'grade', 'name', 'accountId', 'password', 'parent_phone'];

export const REPORT_PATH_NAME = ['/score/reportlookup/result/period', '/score/reportlookup/result/daily'];

export const HELPU_BASE64 =
  'data:image/x-icon;base64,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';

export const LONG_VOCA_TERMS = `제1조 (목적)

본 약관은 오래영어(회사)가 제공하는 지불/결제 수단 (이하 '오래캐쉬'라 함)을 사용함에 있어 회사와 회원 간에 오래캐쉬에 대한 충전 이용에 관해서 상호 간 준수해야 할 사항을 규정함을 목적으로 합니다.

제2조(용어의 정의)

①'회원'이라 함은 본 약관에 동의하고 회사가 제공하는 오래캐쉬를 이용하는 고객을 말합니다.
② 오래캐쉬: 오래캐쉬는 오래영어 서비스 (컨텐츠 및 전자상거래)를 이용할 수 있는 인터넷상의 현금등가의 결제수단을 의미합니다.
③ 충전: 오래캐쉬 일정액을 확보하기 위해 특정 지불수단을 이용하여 현금을 회사에 지불하고, 그 현금의 대가로 오래캐쉬가 적립됩니다. 결제수단을 이용해 오래캐쉬로 충전 시에는 현금 10원당 오래캐쉬 10원으로 충전됩니다.
④ 사용내역취소 (증액): 충전한 오래캐쉬로 유료서비스를 이용하는 중 장애나 기타 사유로 인해 정상적으로 서비스를 이용하지 못했을 경우, 장애신고를 통해 사용된 오래캐쉬를 결제하기 이전 상태로 다시 되돌려 받는 것을 말합니다.
⑤ 환불: 회사가 제공하는 결제수단을 통하여 충전한 오래캐쉬를 현금으로 되돌려 받는 방법으로 결제가 이루어지지 않도록 하는 것을 말합니다. 위에서 정의한 용어 이외의 사항은 관계 법령 및 상관례에서 정하는 바에 따릅니다.

제3조 (오래캐쉬의 사용)

① 오래캐쉬는 내부 서비스나 컨텐츠, 제품을 이용 또는 구매하는 결제수단으로 이용되며, 오래캐쉬 충전/사용은 오래영어ID가 있어야 가능합니다.
② 오래캐쉬 사용 시 확인되지 않은 회원의 경우는 서비스 이용에 제한을 받으실 수 있습니다.
③ 결제정보를 입력한 후에는 회사가 회원의 이용 편의성과 결제수단의 본인확인 및 회원에 대한 청구로 인하여 회원의 결제정보를 보관하여도 무방한 것으로 간주하며, 이 때 회사는 회원의 정보에 대한 내용을 암호화하여 보관해야하며 본인의 동의없이 외부유출이 불가능합니다.
④ 회사는 회원이 제1항에 따라 오래캐쉬를 충전하거나 사용한 경우 회원이 오래캐쉬 잔액을 확인할 수 있도록 하며, 회원은 오래캐쉬를 충전하거나 사용한 경우 즉시 오래캐쉬 잔액을 확인하고 이상이 있는 경우에는 회사에 해당 사실을 통지하여야 합니다. 이 경우 회사는 해당 회원의 오래캐쉬 충전 또는 사용 내역을 확인하여 필요한 조치를 취합니다.
⑤ 오래캐쉬를 이용할 수 있는 인터넷 서비스와 오래캐쉬를 사용하여 결제할 수 있는 유료 서비스는 회사에서 정한 바에 따르며 회사의 정책에 따라 추가, 변경, 삭제될 수 있습니다. 제4조 (오래캐쉬의 차감) 충전한 오래캐쉬에 대한 차감은 회사가 제공하는 유료서비스(컨텐츠, 제품, 문자)를 이용하는 시점에서 즉시 이루어집니다.

제4조 (오래캐쉬의 차감)

충전한 오래캐쉬에 대한 차감은 회사가 제공하는 유료서비스(컨텐츠, 제품, 문자)를 이용하는 시점에서 즉시 이루어집니다.

제5조 (오래캐쉬의 사용제한)

① 회원은 다음 각호에 해당하는 행위를 하여서는 아니되며, 이를 위반할 경우 회사는 당해 회원에 대하여 오래캐쉬 이용을 정지시킬 수 있습니다.
  1. 타인의 ID 및 비밀번호를 부정하게 사용하는 경우
  2. 타인의 명의나 개인정보를 도용하여 서비스를 이용하는 경우
  3. 타인의 결제정보 등을 도용하거나 부정한 행위로 거래를 하는 경우
  4. 회원의 오래캐쉬를 허용하지 아니한 곳에서 양도하는 경우
  5. 다른 회원의 오래캐쉬 사용을 저해하거나, 오래캐쉬 서비스 제공에 지장을
     초래하는 경우
  6. 본 약관에 위반하는 방법으로 오래캐쉬 서비스를 이용하는 경우
  7. 오래캐쉬가 사용되는 회사의 인터넷 서비스 이용약관에 위반하여 서비스를
     이용하는 경우
  8. 기타 법령에 위배되는 행위를 하는 경우
② 회사는오래캐쉬 이용을 제한할 경우 이용 제한 내용과 소명 절차를 회원이 지정한 전자우편, SMS 등으로 통지하여 회원이 소명할 수 있는 기회를 부여합니다.
③ 오래캐쉬 잔액을 장기간 사용하지 않을 시 회사는 회원의 보호차원에서 사용 중지를 할 수 있습니다. 회사에서는 사용 중지된 오래캐쉬를 회원이 언제든 사용을 원할 시, 회원 본인인증을 통하여 사용 가능토록 합니다.

제6조 (오래캐쉬의 충전 방법)

① 오래캐쉬 충전은 회사가 지정하는 결제수단을 통해 충전할 수 있으며 1회 충전당 최저 50,000원 또는 100,000원까지 충전할 수 있습니다.
② 회사가 제공하는 시스템상의 장애에 의하여 충전이 정상적으로 이루어지지 못한 경우에 오래캐쉬로 재충전 받을 수 있습니다.

제7조 (오래캐쉬의 충전 종류)

① 오래캐쉬의 충전을 위해 다음과 같은 결제수단 및 방법이 제공됩니다.
  - 무통장 입금 : 충전할 금액을 선택하신 후 회사의 전용계좌로 입금하여 충전합니다.
② 회사가 제공하는 결제수단은 회사의 운영방침에 따라 이용이 제한될 수 있습니다.

제8조 (오래캐쉬 사용내역 취소 등)

① 회원이 오래캐쉬를 사용해 캐쉬가 차감처리 된 이후에는 오래캐쉬의 사용 취소를 할 수
없습니다.
② 충전한 오래캐쉬로 서비스를 이용하는 중 장애나 기타 사유로 인해 정상적으로 서비스를 이용하지 못했을 경우 이미 차감된 오래캐쉬의 반환을 요청할 수 있습니다.
③ 위 규정에도 불구하고, 서비스를 이용한 날로부터 10일이 경과한 후에는 사용내역 취소가 불가능합니다 (단, 오래영어 관리자 페이지에서 오래캐쉬를 이용한 경우 전자상거래표준약관을 따릅니다.)

제9조 (오래캐쉬의 환불)

① 충전된 오래캐쉬는 잔액 (최초 유료구매 하신 문자 건수 - 사용 문자 건 차감)의 30% 환불 가능합니다. 이때 잔액이 1,000원이하의 경우에는 환불하지 않습니다. (이는 송금수수료 등 제반수수료 및 환불업무에 투여되는 제반 업무비용이 최소 1,000원 이상이기 때문입니다) 다만, 충전 누계 금액의 80% 이상을 사용한 오래캐쉬의 잔액 환불을 요구받는 경우, 잔액의 전액 환불 가능합니다.
② 회사가 제공한 결제수단을 이용하여 비용을 지불하고 오래캐쉬를 구입한 후 유료 서비스 또는 상품을 전혀 사용하지 않은 경우 구입일로부터 7일 이내에는 환불수수료 없이 환불 또는 결제 취소할 수 있습니다.
③ 위의 ②항에도 불구하고 충전에 해당되는 결제수단으로 결제금액을 재환원하는 것으로 환불을 대신하는 경우, 위약금을 징수하지 않습니다.
④ 다음 각 호의 경우 회사가 정한 절차에 따라 환불받을 수 있습니다.
  1. 오래캐쉬를 충전했으나 오래캐쉬를 사용할 수 있는 서비스가 없어 그에 대한 책임이 전적
     으로 회사에 있는 경우 (단, 시스템의 정기점검 등 불가피한 경우는 제외)
  2. 오래캐쉬 잔액이 있는 상태에서 회원이 변경된 약관에 동의하지 않는다는 이유로 탈퇴하고
     회사가 이를 정당하다고 판단하는 경우
  3. 기타 회원의 권리보호를 위하여 회사가 별도로 규정한 경우
⑤ 전항들의 규정에도 불구하고, 다음 각 호에 해당하는 오래캐쉬는 환불이 불가능합니다.
  1. 타인으로부터 양도받은 오래캐쉬
  2. 정상적이지 않은 방법으로 충전한 오래캐쉬

제10조 (오래캐쉬의 양도)

① 오래캐쉬는 원칙적으로 다른 회원에게 양도할 수 없습니다. 단, 양도할 만한 사정이 있음을 회원이 증명하고 정상적인 경우라고 인정되는 경우 회사는 양도하는 회원이 보유한 오래캐쉬 한도 내에서 양도를 승낙할 수 있습니다 (단, 이 경우에도 제9조 제5항에 해당하는 캐쉬의 경우에는 양도되지 않습니다.)
② 전항에 의하여 오래캐쉬를 양도하는 경우 회사는 이에 대한 책임을 지지 않습니다.
③ 회원이 사망한 경우 사망한 회원의 오래캐쉬는 민법의 상속 일반규정에 따라 오래캐쉬의 형태로 양도되며, 양도받는 회원은 이와 관련된 사항을 증명해야 합니다. (단, 이 경우에도 제9조 제5항에 해당하는 캐쉬의 경우에는 양도되지 않습니다.)
④ 오래캐쉬의 양도는 회사 고객센터 문의 또는 온라인 상담을 통해 신청합니다.

제11조 (오래캐쉬의 소멸)

① 오래캐쉬의 유효기간은 5만원권 12개월, 10만원권 18개월이며, 유효기간이 경과하는 동안 오래캐쉬를 단 한번도 적립하거나 사용하지 않은 경우 자동 소멸됩니다. 단, 유효기간 중 오래캐쉬의 추가적인 적립 또는 사용이 있는 경우 다시 해당 일자를 기준으로 5만원권 12개월, 10만원권 18개월간 유효하게 됩니다.
② 상기 1항에 의거 마지막으로 이용한 날로부터 오래캐쉬별 유효기간 경과 후 소멸된 오래캐쉬는 환불하지 않습니다.

제12조 (손해배상)

① 회사는 회사의 중대한 과실로 인하여 충전한 오래캐쉬가 소멸되는 등 회원이 서비스 이용 시 손해를 입는 경우 오래캐쉬 재충전 등 그에 상응하는 적절한 보상을 제공합니다.
② 회사는 회원의 귀책사유나 ①항의 내용 외 발생하는 회원의 손실에 대해서는 일체 책임을 지지 않습니다.

제13조 (면책조항)

① 회사는 천재지변 또는 이에 준하는 불가항력으로 인하여 서비스를 제공할 수 없는 경우에는 서비스 제공에 관한 책임이 면제됩니다.
② 회사는 회원의 귀책사유로 인한 서비스 이용의 장애에 대하여 책임을 지지 않습니다.
③ 회사는 회원이 서비스를 이용하여 기대하는 수익을 상실한 것에 대하여 책임지지 않으며 그 밖의 서비스를 통하여 얻은 자료로 인한 손해에 관하여 책임을 지지 않습니다.
④ 회사는 회원이 서비스에 게재한 정보, 자료, 사실의 신뢰도, 정확성의 내용에 관하여는 책임을 지지 않습니다.

제14조 (재판권 및 준거법)

① 이 약관에 명시되지 않은 사항이 관계법령에 규정되어 있을 경우에는 해당규정에 따릅니다.
② 요금 등 서비스 이용으로 발생한 분쟁에 대해 소송이 제기될 경우 회사의 본사 소재지를 관할하는 법원을 전속 관할법원으로 합니다.`;

export const priceOptions = [
  {
    title: '무료',
    description: '오래영어만의<br />일주일 무제한 무료체험',
    buttonText: '체험중',
    className: 'free',
    color: 'gray',
    unitPrice: '',
    period: '',
  },
  {
    title: '월 정기상품',
    description: '이용료 혜택 없이<br />정기적으로 사용할게요.',
    buttonText: '결제하기',
    className: 'one-month',
    color: '#2bd1b1',
    unitPrice: '4,600원',
    period: 'month',
  },
  {
    title: '학기 상품',
    description: '방학특강, 내신대비 등<br />학기 단위로 사용할게요.',
    buttonText: '결제하기',
    className: 'six-month',
    color: '#1F68FF',
    unitPrice: '3,833원',
    period: 'sixMonth',
  },
  {
    title: '1년 무제한 상품',
    description: '컨텐츠 무제한으로<br />혜택까지 받으며 사용할게요.',
    buttonText: '결제하기',
    className: 'twelve-month',
    color: '#4620e9',
    unitPrice: '2,300원',
    period: 'year',
  },
];

export const paymentMethods = [
  {
    label: '가상계좌',
    description: '생성된 가상계좌는 서비스 사용 기간 동안 평생 사용합니다.',
  },
  {
    label: '카드결제',
    description: '카드정보를 등록하시면 서비스 기간 만료 시, 자동 결제가 이루어집니다.',
  },
  {
    label: '전용계좌',
    account: '하나은행 139-910488-81107 오성훈(오래에듀케이션)',
    description: '서비스 사용을 위한 전용계좌가 발급되고, 납부 즉시 가입 완료됩니다.',
  },
];

export const HOT_HASH_TAGS = ['강의', '예문', '이미지'];
export const NEW_HASH_TAGS = ['예문', '이미지'];
export const NULL_HASH_TAGS = ['이미지'];

export const productData = {
  month: [
    { students: 500, monthlyFee: 1500000, excessFee: 3000 },
    { students: 400, monthlyFee: 1350000, excessFee: 3000 },
    { students: 350, monthlyFee: 1200000, excessFee: 3000 },
    { students: 300, monthlyFee: 1350000, excessFee: 4000 },
    { students: 250, monthlyFee: 900000, excessFee: 3000 },
    { students: 200, monthlyFee: 950000, excessFee: 4000 },
    { students: 190, monthlyFee: 720000, excessFee: 3500 },
    { students: 180, monthlyFee: 690000, excessFee: 3500 },
    { students: 170, monthlyFee: 660000, excessFee: 3500 },
    { students: 160, monthlyFee: 630000, excessFee: 3500 },
    { students: 150, monthlyFee: 600000, excessFee: 3500 },
    { students: 140, monthlyFee: 570000, excessFee: 3500 },
    { students: 130, monthlyFee: 540000, excessFee: 3500 },
    { students: 120, monthlyFee: 510000, excessFee: 3500 },
    { students: 110, monthlyFee: 480000, excessFee: 3500 },
    { students: 100, monthlyFee: 550000, excessFee: 4000 },
    { students: 95, monthlyFee: 430000, excessFee: 4000 },
    { students: 90, monthlyFee: 500000, excessFee: 5000 },
    { students: 85, monthlyFee: 390000, excessFee: 4000 },
    { students: 80, monthlyFee: 450000, excessFee: 5000 },
    { students: 75, monthlyFee: 350000, excessFee: 4000 },
    { students: 70, monthlyFee: 400000, excessFee: 5000 },
    { students: 65, monthlyFee: 310000, excessFee: 4000 },
    { students: 60, monthlyFee: 350000, excessFee: 5000 },
    { students: 55, monthlyFee: 270000, excessFee: 4000 },
    { students: 50, monthlyFee: 300000, excessFee: 5000 },
    { students: 45, monthlyFee: 275000, excessFee: 5000 },
    { students: 40, monthlyFee: 245000, excessFee: 5000 },
    { students: 35, monthlyFee: 215000, excessFee: 5000 },
    { students: 30, monthlyFee: 189000, excessFee: 5000 },
    { students: 25, monthlyFee: 159000, excessFee: 6000 },
    { students: 20, monthlyFee: 129000, excessFee: 6000 },
    { students: 15, monthlyFee: 99000, excessFee: 7000 },
  ],
  sixMonth: [
    { students: 500, monthlyFee: 7500000, excessFee: 3000 },
    { students: 400, monthlyFee: 6750000, excessFee: 3000 },
    { students: 350, monthlyFee: 6000000, excessFee: 3000 },
    { students: 300, monthlyFee: 6750000, excessFee: 4000 },
    { students: 250, monthlyFee: 4500000, excessFee: 3000 },
    { students: 200, monthlyFee: 4750000, excessFee: 4000 },
    { students: 190, monthlyFee: 3600000, excessFee: 3500 },
    { students: 180, monthlyFee: 3450000, excessFee: 3500 },
    { students: 170, monthlyFee: 3300000, excessFee: 3500 },
    { students: 160, monthlyFee: 3150000, excessFee: 3500 },
    { students: 150, monthlyFee: 3000000, excessFee: 3500 },
    { students: 140, monthlyFee: 2850000, excessFee: 3500 },
    { students: 130, monthlyFee: 2700000, excessFee: 3500 },
    { students: 120, monthlyFee: 2550000, excessFee: 3500 },
    { students: 110, monthlyFee: 2400000, excessFee: 3500 },
    { students: 100, monthlyFee: 2750000, excessFee: 4000 },
    { students: 95, monthlyFee: 2150000, excessFee: 4000 },
    { students: 90, monthlyFee: 2500000, excessFee: 5000 },
    { students: 85, monthlyFee: 1950000, excessFee: 4000 },
    { students: 80, monthlyFee: 2250000, excessFee: 5000 },
    { students: 75, monthlyFee: 1750000, excessFee: 4000 },
    { students: 70, monthlyFee: 2000000, excessFee: 5000 },
    { students: 65, monthlyFee: 1550000, excessFee: 4000 },
    { students: 60, monthlyFee: 1750000, excessFee: 5000 },
    { students: 55, monthlyFee: 1350000, excessFee: 4000 },
    { students: 50, monthlyFee: 1500000, excessFee: 5000 },
    { students: 45, monthlyFee: 1375000, excessFee: 5000 },
    { students: 40, monthlyFee: 1225000, excessFee: 5000 },
    { students: 35, monthlyFee: 1075000, excessFee: 5000 },
    { students: 30, monthlyFee: 945000, excessFee: 5000 },
    { students: 25, monthlyFee: 795000, excessFee: 6000 },
    { students: 20, monthlyFee: 645000, excessFee: 6000 },
    { students: 15, monthlyFee: 495000, excessFee: 7000 },
  ],
  year: [
    { students: 500, monthlyFee: 9000000, excessFee: 3000 },
    { students: 400, monthlyFee: 8100000, excessFee: 3000 },
    { students: 350, monthlyFee: 7200000, excessFee: 3000 },
    { students: 300, monthlyFee: 8100000, excessFee: 4000 },
    { students: 250, monthlyFee: 5400000, excessFee: 3000 },
    { students: 200, monthlyFee: 5700000, excessFee: 4000 },
    { students: 190, monthlyFee: 4320000, excessFee: 3500 },
    { students: 180, monthlyFee: 4140000, excessFee: 3500 },
    { students: 170, monthlyFee: 3960000, excessFee: 3500 },
    { students: 160, monthlyFee: 3780000, excessFee: 3500 },
    { students: 150, monthlyFee: 3600000, excessFee: 3500 },
    { students: 140, monthlyFee: 3420000, excessFee: 3500 },
    { students: 130, monthlyFee: 3240000, excessFee: 3500 },
    { students: 120, monthlyFee: 3060000, excessFee: 3500 },
    { students: 110, monthlyFee: 2880000, excessFee: 3500 },
    { students: 100, monthlyFee: 3300000, excessFee: 4000 },
    { students: 95, monthlyFee: 2580000, excessFee: 4000 },
    { students: 90, monthlyFee: 2500000, excessFee: 5000 },
    { students: 85, monthlyFee: 2340000, excessFee: 4000 },
    { students: 80, monthlyFee: 2700000, excessFee: 5000 },
    { students: 75, monthlyFee: 2100000, excessFee: 4000 },
    { students: 70, monthlyFee: 2400000, excessFee: 5000 },
    { students: 65, monthlyFee: 1860000, excessFee: 4000 },
    { students: 60, monthlyFee: 2100000, excessFee: 5000 },
    { students: 55, monthlyFee: 1620000, excessFee: 4000 },
    { students: 50, monthlyFee: 1800000, excessFee: 5000 },
    { students: 45, monthlyFee: 1650000, excessFee: 5000 },
    { students: 40, monthlyFee: 1470000, excessFee: 5000 },
    { students: 35, monthlyFee: 1290000, excessFee: 5000 },
    { students: 30, monthlyFee: 1134000, excessFee: 5000 },
    { students: 25, monthlyFee: 954000, excessFee: 6000 },
    { students: 20, monthlyFee: 774000, excessFee: 6000 },
    { students: 15, monthlyFee: 594000, excessFee: 7000 },
  ],
};

export const productDetailData = [
  {
    productCode: 'C020H',
    studentCount: 20,
    months: 'sixMonth',
    price: 645000,
  },
  {
    productCode: 'C020M',
    studentCount: 20,
    months: 'month',
    price: 129000,
  },
  {
    productCode: 'C020Y',
    studentCount: 20,
    months: 'year',
    price: 774000,
  },
  {
    productCode: 'C050H',
    studentCount: 50,
    months: 'sixMonth',
    price: 1500000,
  },
  {
    productCode: 'C050M',
    studentCount: 50,
    months: 'month',
    price: 300000,
  },
  {
    productCode: 'C050Y',
    studentCount: 50,
    months: 'year',
    price: 1800000,
  },
  {
    productCode: 'P030H',
    studentCount: 30,
    months: 'sixMonth',
    price: 945000,
  },
  {
    productCode: 'P030M',
    studentCount: 30,
    months: 'month',
    price: 189000,
  },
  {
    productCode: 'P030Y',
    studentCount: 30,
    months: 'year',
    price: 1134000,
  },
  {
    productCode: 'S015H',
    studentCount: 15,
    months: 'sixMonth',
    price: 495000,
  },
  {
    productCode: 'S015M',
    studentCount: 15,
    months: 'month',
    price: 99000,
  },
  {
    productCode: 'S015Y',
    studentCount: 15,
    months: 'year',
    price: 594000,
  },
];

export const CARD_PAYMENT_TERMS_1 = `
                    <article className='p-post text--left'>
        <c>전자금융거래 기본약관(이용자용)</c>
        <br/>
        <p>제1조 (목적)</p>
        <p>
          이 약관은 전자지급결제대행서비스 및 결제대금예치서비스를 제공하는 토스페이먼츠 주식회사(이하
          &apos;회사&apos;라 합니다)와 이용자 사이의 전자금융거래에 관한 기본적인 사항을 정함으로써 전자금융거래의
          안정성과 신뢰성을 확보함에 그 목적이 있습니다.
        </p><br/>
        <p>제2조 (용어의 정의)</p>
        <p>이 약관에서 정하는 용어의 정의는 다음과 같습니다.</p>
        <p>
          ① 전자금융거래&apos;라 함은 회사가 전자적 장치를 통하여 전자지급결제대행서비스 및 결제대금예치서비스(이하
          &apos;전자금융거래 서비스&apos;라고 합니다)를 제공하고, 이용자가 회사의 구성원과 직접 대면하거나 의사소통을
          하지 아니하고 전산화된 방식으로 이를 이용하는 거래를 말합니다.
        </p><br/>
        <p>
          ② &apos;전자지급결제대행 서비스&apos;라 함은 전자적 방법으로 재화의 구입 또는 용역의 이용에 있어서
          지급결제정보를 송신하거나 수신하는 것 또는 그 대가의 정산을 대행하거나 매개하는 서비스를 말합니다.
        </p><br/>
        <p>
          ③ ‘결제대금예치서비스&apos;라 함은 이용자가 재화의 구입 또는 용역의 이용에 있어서 그 대가(이하
          &apos;결제대금&apos;이라 한다)의 전부 또는 일부를 재화 또는 용역(이하 &apos;재화 등&apos;이라 합니다)을
          공급받기 전에 미리 지급하는 경우, 회사가 이용자의 물품수령 또는 서비스 이용 확인 시점까지 결제대금을 예치하는
          서비스를 말합니다.
        </p><br/>
        <p>
          ④ &apos;이용자&apos;라 함은 이 약관에 동의하고 회사가 제공하는 전자지급결제대행 서비스를 이용하는 자를
          말합니다.
        </p><br/>
        <p>
          ⑤ &apos;접근매체&apos;라 함은 전자금융거래에 있어서 거래지시를 하거나 이용자 및 거래내용의 진실성과 정확성을
          확보하기 위하여 사용되는 수단 또는 정보로서 전자식 카드 및 이에 준하는 전자적 정보(신용카드번호를 포함한다),
          &apos;전자서명법&apos;상의 인증서, 금융기관 또는 전자금융업자에 등록된 이용자번호, 이용자의 생체정보, 이상의
          수단이나 정보를 사용하는데 필요한 비밀번호 등 전자금융거래법 제2조 제10호에서 정하고 있는 것을 말합니다.
        </p><br/>
        <p>
          ⑥ &apos;거래지시&apos;라 함은 이용자가 전자금융거래계약에 따라 금융기관 또는 전자금융업자에게 전자금융거래의
          처리를 지시하는 것을 말합니다.
        </p><br/>
        <p>
          ⑦ &apos;오류&apos;라 함은 이용자의 고의 또는 과실 없이 전자금융거래가 전자금융거래계약 또는 이용자의
          거래지시에 따라 이행되지 아니한 경우를 말합니다.
        </p><br/>
        <p>제3조 (약관의 명시 및 변경)</p>
        <p>
          ① 회사는 이용자가 전자지급결제대행 서비스를 이용하기 전에 이 약관을 게시하고 이용자가 이 약관의 중요한 내용을
          확인할 수 있도록 합니다.
        </p><br/>
        <p>
          ② 회사는 이용자의 요청이 있는 경우 서면제공 방식 또는 전자문서의 전송방식에 의하여 본 약관의 사본을 이용자에게
          교부합니다.
        </p><br/>   
        <p>
          ③ 회사가 약관을 변경하는 때에는 그 시행일 1월 전에 변경되는 약관을 지급결제정보 입력화면 및 회사의 홈페이지에
          게시함으로써 이용자에게 공지합니다.
        </p><br/>
        <p>
          ④ 이용자는 제3항의 규정에 따른 약관의 변경내용이 게시되거나 통지된 후부터 변경되는 약관의 시행일 전의
          영업일까지 전자금융거래의 계약을 해지할 수 있습니다. 전단의 기간 안에 이용자가 약관의 변경내용에 대하여 이의를
          제기하지 아니하는 경우에는 약관의 변경을 승인한 것으로 봅니다.
        </p><br/>
        <p>제4조 (전자지급결제대행서비스의 종류)</p>
        <p>회사가 제공하는 전자지급결제대행서비스는 지급결제수단에 따라 다음과 같이 구별됩니다.</p>
        <p>
          ① 신용카드결제대행서비스: 이용자가 결제대금의 지급을 위하여 제공한 지급결제수단이 신용카드인 경우로서, 회사가
          전자결제시스템을 통한 신용카드 지불정보의 송,수신 및 결제대금의 정산을 대행하거나 매개하는 서비스를 말합니다.
        </p><br/>
        <p>
          ② 계좌이체대행서비스: 이용자가 결제대금을 회사의 전자결제시스템을 통하여 금융기관에 등록한 자신의 계좌에서
          출금하여 원하는 계좌로 이체할 수 있는 실시간 송금 서비스를 말합니다.
        </p><br/>
        <p>
          ③ 가상계좌서비스: 이용자가 결제대금을 현금으로 결제하고자 경우 회사의 전자결제시스템을 통하여 자동으로
          이용자만의 고유한 일회용 계좌의 발급을 통하여 결제대금의 지급이 이루어지는 서비스를 말합니다.
        </p><br/>
        <p>
          ④ 기타: 회사가 제공하는 서비스로서 지급결제수단의 종류에 따라 &apos;휴대폰 결제대행서비스&apos;,
          &apos;KT전화(ARS,폰빌)결제대행서비스&apos;, &apos;상품권결제대행서비스&apos;등이 있습니다.
        </p><br/>
        <p>제5조 (결제대금예치서비스의 내용)</p>
        <p>
          ① 이용자(이용자의 동의가 있는 경우에는 재화 등을 공급받을 자를 포함합니다. 이하 본조에서 같습니다)는 재화 등을
          공급받은 사실을 재화 등을 공급받은 날부터 3영업일 이내에 회사에 통보하여야 합니다.
        </p><br/>
        <p>
          ② 회사는 이용자로부터 재화 등을 공급받은 사실을 통보 받은 후 회사와 통신판매업자간 사이에서 정한 기일 내에
          통신판매업자에게 결제대금을 지급합니다.
        </p><br/>
        <p>
          ③ 회사는 이용자가 재화 등을 공급받은 날부터 3영업일이 지나도록 정당한 사유의 제시 없이 그 공급받은 사실을
          회사에 통보하지 아니하는 경우에는 이용자의 동의 없이 통신판매업자에게 결제대금을 지급할 수 있습니다.
        </p><br/>
        <p>
          ④ 회사는 통신판매업자에게 결제대금을 지급하기 전에 이용자에게 결제대금을 환급받을 사유가 발생한 경우에는 그
          결제대금을 소비자에게 환급합니다.
        </p><br/>
        <p>
          ⑤ 회사는 이용자와의 결제대금예치서비스 이용과 관련된 구체적인 권리,의무를 정하기 위하여 본 약관과는 별도로
          결제대금예치서비스이용약관을 제정할 수 있습니다.
        </p><br/>
        <p>제6조 (접근매체의 선정, 관리 등)</p>
        <p>
          ① 회사는 전자지급결제대행 서비스 제공 시 접근매체를 선정하여 이용자의 신원, 권한 및 거래지시의 내용 등을
          확인할 수 있습니다.
        </p><br/>   
        <p>② 이용자는 접근매체를 제3자에게 대여하거나 사용을 위임하거나 양도 또는 담보 목적으로 제공할 수 없습니다.</p>
        <p>
          ③ 이용자는 자신의 접근매체를 제3자에게 누설 또는 노출하거나 방치하여서는 안되며, 접근매체의 도용이나 위조 또는
          변조를 방지하기 위하여 충분한 주의를 기울여야 합니다.
        </p><br/>
        <p>
          ④ 회사는 이용자로부터 접근매체의 분실이나 도난 등의 통지를 받은 때에는 그 때부터 제3자가 그 접근매체를
          사용함으로 인하여 이용자에게 발생한 손해를 배상할 책임이 있습니다.
        </p><br/>
        <p>제7조 (회사의 책임)</p>
        <p>
          ① 접근매체의 위조나 변조로 발생한 사고로 인하여 이용자에게 발생한 손해에 대하여 배상책임이 있습니다. 다만,
          이용자가 접근매체를 제3자에게 대여하거나 그 사용을 위임한 경우 또는 양도나 담보의 목적으로 제공한 경우, 회사가
          보안강화를 위하여 전자금융거래 시 요구하는 추가적인 보안조치를 이용자가 정당한 사유 없이 거부하여 정보통신망에
          침입하여 거짓이나 그 밖의 부정한 방법으로 획득한 접근매체의 이용으로 사고가 발생한 경우, 이용자가 제6조
          제2항에 위반하거나 제3자가 권한 없이 이용자의 접근매체를 이용하여 전자금융거래를 할 수 있음을 알았거나 알 수
          있었음에도 불구하고 이용자가 자신의 접근매체를 누설 또는 노출하거나 방치한 경우 그 책임의 전부 또는 일부를
          이용자가 부담하게 할 수 있습니다.
        </p><br/>
        <p>
          ② 회사는 계약체결 또는 거래지시의 전자적 전송이나 처리과정에서 발생한 사고로 인하여 이용자에게 손해가 발생한
          경우에는 그 손해를 배상할 책임이 있습니다. 다만, 본조 제1항 단서에 해당하거나 법인(&apos;중소기업기본법&apos;
          제2조 제2항에 의한 소기업을 제외한다)인 이용자에게 손해가 발생한 경우로서 회사가 사고를 방지하기 위하여
          보안절차를 수립하고 이를 철저히 준수하는 등 합리적으로 요구되는 충분한 주의의무를 다한 경우 그 책임의 전부
          또는 일부를 이용자가 부담하게 할 수 있습니다.
        </p><br/>
        <p>
          ③ 회사는 전자금융거래를 위한 전자적 장치 또는 ‘정보통신망 이용촉진 및 정보보호 등에 관한 법률’
          제2조제1항제1호에 따른 정보통신망에 침입하여 거짓이나 그 밖의 부정한 방법으로 획득한 접근매체의 이용으로
          발생한 사고로 인하여 이용자에게 그 손해가 발생한 경우에는 그 손해를 배상할 책임이 있습니다.
        </p><br/>
        <p>제8조 (거래내용의 확인)</p>
        <p>
          ① 회사는 이용자와 미리 약정한 전자적 방법을 통하여 이용자의 거래내용(이용자의 &apos;오류정정 요구사실 및
          처리결과에 관한 사항&apos;을 포함합니다)을 확인할 수 있도록 하며, 이용자의 요청이 있는 경우에는 요청을 받은
          날로부터 2주 이내에 전자적양식, 모사전송, 서면 등의 방법으로 거래내용에 관한 서면을 교부합니다. 전자적 장치의
          운영장애, 그 밖의 사유로 거래내용을 확인하게 할 수 없는 때에는 인터넷 등을 이용하여 즉시 그 사유를 알리고, 그
          사유가 종료된 때부터 이용자가 거래내용을 확인할 수 있도록 하여야 합니다.
        </p><br/>
        <p>
          ② 회사가 이용자에게 제공하는 거래내용 중 거래계좌의 명칭 또는 번호, 거래의 종류 및 금액, 거래상대방을 나타내는
          정보, 거래일자, 전자적 장치의 종류 및 전자적 장치를 식별할 수 있는 정보와 해당 전자금융거래와 관련한 전자적
          장치의 접속기록은 5년간, 건당 거래금액이 1만원 이하인 소액 전자금융거래에 관한 기록, 전자지급수단 이용시
          거래승인에 관한 기록, 이용자의 오류정정 요구사실 및 처리결과에 관한 사항은 1년간의 기간을 대상으로 하되,
          회사가 가맹점에 대한 전자지급결제대행 서비스 제공의 대가로 수취한 수수료에 관한 사항은 제공하는 거래내용에서
          제외됩니다.
        </p><br/>
        <p>
          ③ 이용자가 본조 제1항에서 정한 서면교부를 요청하고자 할 경우 다음의 주소 및 전화번호로 요청할 수 있습니다.
        </p><br/>
        <ul>
          <li>주소 : 서울특별시 강남구 테헤란로 131 한국지식재산센터 15층 토스페이먼츠 주식회사</li>
          <li>이메일 주소 : support@tosspayments.com</li>
          <li>전화번호 : 1544-7772</li>
        </ul><br/>
        <p>제9조 (오류의 정정 등)</p>
        <p>
          ① 이용자는 전자지급결제대행 서비스를 이용함에 있어 오류가 있음을 안 때에는 회사에 대하여 그 정정을 요구할 수
          있습니다.
        </p><br/>
        <p>
          ② 회사는 전항의 규정에 따른 오류의 정정요구를 받은 때에는 이를 즉시 조사하여 처리한 후 정정요구를 받은 날부터
          2주 이내에 그 결과를 이용자에게 알려 드립니다.
        </p><br/>
        <p>③ 이용자는 다음의 주소 및 전화번호로 본 조항상의 정정 요구를 할 수 있습니다.</p>
        <ul>
          <li>주소 : 서울특별시 강남구 테헤란로 131 한국지식재산센터 15층 토스페이먼츠 주식회사</li>
          <li>이메일 주소 : support@tosspayments.com</li>
          <li>전화번호: 1544 - 7772</li>
        </ul><br/>  
        <p>
          ④ 회사는 스스로 전자금융거래에 오류가 있음을 안 때에는 이를 즉시 조사하여 처리한 후 오류가 있음을 안 날부터
          2주 이내에 오류의 원인과 처리 결과를 이용자에게 알려 드립니다.
        </p><br/>
        <p>제10조 (전자지급결제대행 서비스 이용 기록의 생성 및 보존)</p>
        <p>
          ① 회사는 이용자가 전자지급결제대행 서비스 이용거래의 내용을 추적, 검색하거나 그 내용에 오류가 발생한 경우에
          이를 확인하거나 정정할 수 있는 기록을 생성하여 보존합니다.
        </p><br/>
        <p>② 전항의 규정에 따라 회사가 보존하여야 하는 기록의 종류 및 보존방법은 제8조 제2항에서 정한 바에 따릅니다.</p><br/>
        <p>제11조 (거래지시의 철회 제한)</p>
        <p>① 이용자가 전자지급거래를 한 경우, 지급의 효력은 ‘전자금융거래법’ 제13조 각호의 규정에 따릅니다.</p>
        <p>
          ② 이용자는 ‘전자금융거래법’ 제13조 각호의 규정에 따라 지급의 효력이 발생하기전까지 거래지시를 철회할 수
          있습니다. 단, 금융기관, 이동통신사 등의 규정에 의거 거래지시의 철회가 제한될 수 있습니다.
        </p><br/>
        <p>③ 전자지급수단별 거래지시의 철회 방법 및 제한 등은 다음 각호와 같습니다.</p>
        <ol>
          <li>
            신용카드결제, 계좌이체결제, 가상계좌결제 : 전자상거래 등에서의 소비자보호에 관한 법률 등 관련 법령에서 정한
            바에 따라 재화의 구입 또는 용역의 이용 거래에서의 청약의 철회 등을 한 경우에 한하여 철회가 가능합니다.
          </li>
          <li>
            휴대폰결제, KT전화(ARS,폰빌)결제: 전 가호의 방법에 따른 청약철회 요청건 중 이동통신사의 규정에 의거 결제일
            해당월 말일까지 발생한 거래건에 한하여 철회가 가능합니다.
          </li>
          <li>
            상품권결제: 전 가호의 방법에 따른 청약철회 요청 건 중 시스템 장애 등으로 정상적인 서비스를 이용하지 못한
            경우에 한하여 결제일로부터 10일 이내 청약 철회가 가능합니다.
          </li>
        </ol><br/>
        <p>제12조 (추심이체의 출금 동의 및 철회)</p>
        <p>
          ① 회사는 이용자의 요청이 있는 경우 이용자의 계좌가 개설되어 있는 금융회사 등이 추심이체를 실행할 수 있도록
          금융회사 등을 대신하여 전자금융거래법령 등 관련 법령에 따른 방법으로 출금에 대한 동의를 진행합니다.
        </p><br/>
        <p>② 회사는 전 항에 따른 이용자의 동의 사항을 추심 이체를 실행하는 해당 금융회사 등에 제출합니다.</p><br/>
        <p>
          ③ 이용자는 이용자의 계좌의 원장에 출금기록이 끝나기 전까지 회사 또는 해당 금융회사 등에 제1항의 규정에 따른
          동의의 철회를 요청할 수 있습니다.
        </p><br/>
        <p>
          ④ 전 항에도 불구하고 회사 또는 금융회사 등은 대량으로 처리하는 거래 또는 예약에 따른 거래 등의 경우에는 미리
          이용자와 정한 약정에 따라 동의의 철회시기를 달리 정할 수 있습니다.
        </p><br/>
        <p>
          ⑤ 이용자가 제3항에 따라 출금 동의 철회를 요청한 경우, 이용자는 출금 동의 철회 요청 이후 발생한 출금에 대해서
          제14조 제1항의 담당자에게 이의를 제기할 수 있습니다. 다만, 본 조항은 동의 철회요청 이전에 발생한 출금에
          대해서는 적용되지 않습니다.
        </p><br/>
        <p>제13조 (전자금융거래정보의 제공금지)</p>
        <p>
          회사는 전자지급결제대행서비스 및 결제대금예치서비스를 제공함에 있어서 취득한 이용자의 인적사항, 이용자의 계좌,
          접근매체 및 전자금융거래의 내용과 실적에 관한 정보 또는 자료를 이용자의 동의를 얻지 아니하고 제3자에게
          제공,누설하거나 업무상 목적 외에 사용하지 아니합니다. 단, ‘금융실명 거래 및 비밀 보장에 관한 법률’ 제4조 제1항
          단서의 규정에 따른 경우 그 밖의 다른 법률에서 정하는 바에 따른 경우에는 그러하지 아니합니다.
        </p><br/>
        <p>제14조 (분쟁처리 및 분쟁조정)</p>
        <p>
          ① 이용자는 다음의 분쟁처리 책임자 및 담당자에 대하여 전자지급결제대행 서비스 및 결제대금예치서비스 이용과
          관련한 의견 및 불만의 제기, 손해배상의 청구 등의 분쟁처리를 요구할 수 있습니다.
        </p>
        <ul>
          <li>담당자 : 토스페이먼츠 RM(리스크)팀</li>
          <li>연락처 : 전화번호 1544-7772, 팩스 02-6919-2354</li>
          <li>이메일 : rm@tosspayments.com</li>
        </ul><br/>
        <p>
          ② 이용자가 회사에 대하여 분쟁처리를 신청한 경우에는 회사는 15일 이내에 이에 대한 조사 또는 처리 결과를
          이용자에게 안내합니다.
        </p><br/>
        <p>
          ③ 이용자는 &apos;금융위원회의 설치 등에 관한 법률&apos; 제51조의 규정에 따른 금융감독원의 금융분쟁조정위원회나
          &apos;소비자기본법&apos; 제35조 제1항의 규정에 따른 소비자원에 회사의 전자지급결제대행서비스 및
          결제대금예치서비스의 이용과 관련한 분쟁조정을 신청할 수 있습니다.
        </p><br/>
        <p>제15조 (회사의 안정성 확보 의무)</p>
        <p>
          회사는 전자금융거래의 안전성과 신뢰성을 확보할 수 있도록 전자금융거래의 종류별로 전자적 전송이나 처리를 위한
          인력, 시설, 전자적 장치 등의 정보기술부문 및 전자금융업무에 관하여 금융위원회가 정하는 기준을 준수합니다.
        </p><br/>
        <p>제16조 (이용시간)</p>
        <p>
          ① 회사는 이용자에게 연중무휴 1일 24시간 전자금융거래 서비스를 제공함을 원칙으로 합니다. 단, 금융기관 기타
          결제수단 발행업자의 사정에 따라 변경될 수 있습니다.
        </p><br/>
        <p>
          ② 회사는 정보통신설비의 보수, 점검 기타 기술상의 필요나 금융기관 기타 결제수단 발행업자의 사정에 의하여 서비스
          중단이 불가피한 경우, 서비스 중단 3일 전까지 게시가능한 전자적 수단을 통하여 서비스 중단 사실을 게시한 후
          서비스를 일시 중단할 수 있습니다. 다만, 시스템 장애복구, 긴급한 프로그램 보수, 외부요인 등 불가피한 경우에는
          사전 게시없이 서비스를 중단할 수 있습니다.
        </p><br/>
        <p>제17조 (약관외 준칙 및 관할)</p>
        <p>
          ① 이 약관에서 정하지 아니한 사항에 대하여는 전자금융거래법, 전자상거래 등에서의 소비자 보호에 관한 법률,
          통신판매에 관한 법률, 여신전문금융업법 등 소비자보호 관련 법령에서 정한 바에 따릅니다.
        </p><br/>
        <p>② 회사와 이용자간에 발생한 분쟁에 관한 관할은 민사소송법에서 정한 바에 따릅니다.</p><br/>
      </article>
              `;

export const CARD_PAYMENT_TERMS_2 = `
             <article class="p-post text--left"><c>개인(신용)정보 수집·이용 동의</c><br/>
<p>토스페이먼츠(이하 "회사"라 함)는 '신용정보의 이용 및 보호에 관한 법률', '전자금융거래법', '전자상거래 등에서의 소비자보호에 관한 법률', '정보통신망 이용촉진 및 정보보호  등에 관한 법률' 및 '개인정보 보호법' 등 관련 법령을 준수하여, 이용자 권익 보호에 최선을 다하고 있습니다.</p><br/>
<p>1. 개인(신용)정보의 수집·이용 목적</p>
<p><c>전자금융거래 서비스 제공</c></p>
<ul>
<li>전자결제 처리(거래승인, 취소, 환불 등) 및 결과 통보</li>
<li>결제과정에서 이용자 인증 및 본인확인</li>
<li>결제 알림 메일/문자 발송</li>
<li>현금영수증 및 세금계산서 발행</li>
<li>상품 배송 등 전자상거래 관련 서비스 제공</li>
</ul><br/>
<p><c>서비스 이용자 관리 및 민원대응</c></p>
<ul>
<li>고객 불만 및 민원처리</li>
<li>금융사고 조사, 분쟁해결, 법령상 의무이행</li>
<li>새로운 정보와 고지사항의 안내</li>
</ul><br/>
<p><c>인구학적 특성에 따른 통계자료 활용</c></p>
<ul>
<li>이용 빈도 파악 및 통계학적 특성 분석, 신규 서비스 개발</li>
<li>서비스의 유효성 확인, 접속빈도 파악, 회원의 서비스이용에 대한 통계자료 활용</li>
</ul><br/>
<p>※ 회사는 개인정보를 위의 목적으로 처리하며, 동의 받은 목적 이외의 용도로 처리하지 않습니다.</p><br/>
<p>2. 수집·이용하는 개인(신용)정보 항목</p>
<p><c>전자결제 서비스 이용자 및 구매정보</c></p>
<ul>
<li>상품 주문번호, 구매자명, 구매자ID, 휴대폰번호, 이메일, 결제금액,  상품명</li>
</ul><br/>
<p><c>결제수단별 결제 정보</c></p>
<ul>
<li>신용카드: 카드번호, 유효기간, 생년월일 혹은 사업자번호, 비밀번호 앞 2자리</li>
<li>휴대폰: 휴대폰번호, 생년월일, 이동통신사</li>
<li>가상계좌: 은행명, 입금자명, 생년월일 또는 사업자번호</li>
<li>상품권: 상품권 번호, 상품권 발행사 아이디, 비밀번호</li>
<li>현금영수증 발급정보 : 휴대폰번호, 현금영수증카드, 기타카드, 사업자번호 (택1)</li>
<li>결제 정보 수신 및 결제대금예치서비스: (선택)이메일주소, 휴대폰번호</li>
</ul><br/>
<p>※ 이용자가 선택한 결제수단에 해당하는 항목만 처리함</p><br/>
<p>3. 개인(신용)정보의 보유 및 이용기간</p>
<p>원칙적으로 개인(신용)정보의 수집·이용 목적이 달성되면 지체 없이 파기합니다. 단, 관련 법령의 규정 또는 회사 내부 방침에 의하여 보존할 필요가 있는 경우 아래에서 정한 기간 동안 개인정보를 보유합니다.</p><br/>
<p><c>부정 이용 방지를 위한 결제 이용에 관한 기록</c></p>
<ul>
<li>보존 근거: 부정 이용 방지 및 탐지</li>
<li>보존기간: <c>5년</c></li>
</ul><br/>
<p><c>휴대폰 본인확인 서비스 이용에 관한 기록</c></p>
<ul>
<li>보존 근거: 정보통신 이용촉진 및 정보보호 등에 관한 법률</li>
<li>보존기간: <c>6개월</c></li>
</ul><br/>
<p><c>계약 또는 청약철회 등에 관한 기록</c></p>
<ul>
<li>보존 근거: 전자상거래 등에서의 소비자보호에 관한 법률</li>
<li>보존기간: <c>5년</c></li>
</ul><br/>
<p><c>1만원 이상 대금결제 및 재화 등의 공급에 관한 기록</c></p>
<ul>
<li>보존 근거: 전자금융거래법</li>
<li>보존기간: <c>5년</c></li>
</ul><br/>
<p><c>1만원 미만 대금결제 및 재화 등의 공급에 관한 기록</c></p>
<ul>
<li>보존 근거: 전자금융거래법</li>
<li>보존기간: <c>1년</c></li>
</ul><br/>
<p><c>소비자의 불만 또는 분쟁처리에 관한 기록</c></p>
<ul>
<li>보존 근거: 전자상거래 등에서의 소비자보호에 관한 법률</li>
<li>보존기간: <c>3년</c></li>
</ul><br/>
<p><c>통신사실확인자료: 웹사이트 방문에 관한 기록</c></p>
<ul>
<li>보존 근거: 통신비밀보호법</li>
<li>보존기간: <c>3개월</c></li>
</ul><br/>
<p>4. 이용자는 회사의 개인(신용)정보 수집·이용 동의를 거부할 권리가 있습니다.</p>
<p>다만, 개인(신용)정보의 수집·이용 동의를 거부할 경우 전자결제 서비스의 이용이 제한될 수 있음을 알려드립니다.</p></article>
`;

export const CARD_PAYMENT_TERMS_3 = `
<article class="p-post text--left css-v0j40w"><c>개인(신용)정보 제3자 제공 동의</c><br/>
<p>토스페이먼츠(이하 "회사"라 함)는 '신용정보의 이용 및 보호에 관한 법률', '전자금융거래법', '전자상거래 등에서의 소비자보호에 관한 법률', '정보통신망 이용촉진 및 정보보호 등에 관한 법률' 및 '개인정보 보호법' 등 관련 법령을 준수하여, 이용자 권익 보호에 최선을 다하고 있습니다.
회사는 전자결제서비스의 제공을 위하여 개인(신용)정보를 서비스 및 결제수단 별로 아래와 같이 제3자에게 제공하고 있습니다.</p><br/>
<p>1. 개인(신용)정보 제공 목적, 제공받는 자 및 항목</p>
<p>회사는 <c>이용자가 요청한 전자결제 서비스 제공을 위하여</c> 결제 원천사로 다음과 같은 개인(신용)정보를 제공합니다.</p><br/>
<p><c>신용카드 결제</c></p>
<ul>
<li>
<p>제공받는 자</p>
<ul>
<li>[신용카드사] <c>KB국민카드, 비씨카드, 롯데카드, 삼성카드, NH농협카드, 현대카드, 신한카드, KEB하나카드, 우리카드</c></li>
<li>[은행] <c>경남은행, 광주은행, 국민은행, 기업은행, 농협은행, 대구은행, 부산은행, KDB산업은행, 새마을금고, 수협은행, 신한은행, 신협, 우리은행, 우체국, 전북은행, 제주은행, KEB하나은행, 씨티은행, SC제일은행, 산림조합중앙회, 케이뱅크, 카카오뱅크, 토스뱅크</c></li>
<li>[VAN사] <c>㈜코밴, ㈜한국신용카드결제, (주)나이스정보통신</c></li>
</ul>
</li>
<li>
<p>제공항목</p>
<ul>
<li>[거래정보]: 카드번호, 고객명, 생년월일, 전화번호  </li>
<li>[비인증결제의 경우 거래정보]: 카드번호, 유효기간, 생년월일, 카드 비밀번호 앞 2자리  </li>
<li>※하나/농협카드는 비밀번호 4자리, 그 외 카드사는 비밀번호 앞 2자리</li>
</ul>
</li>
</ul><br/>
<p><c>해외카드 결제</c></p>
<ul>
<li>제공받는 자: <c>VISA, MASTER, JCB, AMEX, Discover, Diners, 유니온페이 인터내셔널</c></li>
<li>제공항목: 카드번호, 유효기간, 전화번호, 카드 비밀번호</li>
</ul><br/>
<p><c>간편 결제</c></p>
<ul>
<li>
<p>제공받는 자:</p>
<table border="1" cellspacing="10" cellpadding="8" style="width:100%; text-align: center;">
<thead>
<tr>
<th>사업자명</th>
<th>서비스명</th>
<th>사업자명</th>
<th>서비스명</th>
</tr>
</thead>
<tbody>
<tr>
<td rowspan="2" style="vertical-align: middle;">㈜비바리퍼블리카</td>
<td>토스페이</td>
<td>엔에이치엔페이코㈜</td>
<td>페이코</td>
</tr>
<tr>
<td>퀵계좌이체</td>
<td>㈜카카오페이</td>
<td>카카오페이</td>
</tr>
<tr>
<td>㈜에스에스지페이먼츠</td>
<td>SSG페이</td>
<td>네이버파이낸셜㈜</td>
<td>네이버페이</td>
</tr>
<tr>
<td>롯데멤버스㈜</td>
<td>L.PAY</td>
<td>블루월넛㈜</td>
<td>핀페이</td>
</tr>
<tr>
<td>삼성전자㈜</td>
<td>삼성페이</td>
<td>Apple Korea㈜</td>
<td>Apple Pay</td>
</tr>
</tbody>
</table>
</li>
<li>제공항목: 전화번호, 상품명, 상품금액, [선택] 성명, ID, 이메일주소</li>
</ul><br/>
<p><c>신용카드 ARS결제</c></p>
<ul>
<li>제공받는 자: <c>㈜엘지유플러스</c></li>
<li>제공항목: 카드번호, 전화번호, 유효기간</li>
</ul><br/>
<p><c>계좌이체 결제</c></p>
<ul>
<li>제공받는 자: <c>금융결제원</c></li>
<li>제공항목: 상품명, 결제금액</li>
</ul><br/>
<p><c>가상계좌 결제</c></p>
<ul>
<li>제공받는 자: [은행] <c>국민은행, 농협은행, 우리은행, 신한은행, KEB하나은행, 기업은행, 우체국, 부산은행, 경남은행, 대구은행, 수협은행, 광주은행, 전북은행, 새마음금고, 케이뱅크</c></li>
<li>제공항목: 가상계좌번호</li>
</ul><br/>
<p><c>휴대폰 결제</c></p>
<ul>
<li>
<p>제공받는 자</p>
<ul>
<li>[통신사] <c>SK텔레콤㈜, ㈜케이티, ㈜엘지유플러스</c></li>
<li>[중개사] <c>㈜다날, 갤럭시아머니트리㈜, 페이레터(주)</c></li>
</ul>
</li>
<li>제공항목: 이통사정보, 휴대폰번호</li>
</ul><br/>
<p><c>상품권 결제</c></p>
<ul>
<li>제공받는 자: <c>㈜한국문화진흥, ㈜페이즈북앤라이프</c></li>
<li>제공항목: 상품권번호 또는 상품권발행사ID, 비밀번호</li>
</ul><br/>
<p><c>글로벌 서비스</c></p>
<ul>
<li>
<p>제공받는 자:</p>
<ul>
<li><c>PayPal Pte. Ltd.</c> (PayPal)</li>
<li><c>Alipay Singapore E-Commerce Private Limited</c> (Alipay+CN, AlipayHK, BillEase, Boost, BPI, DANA, GCash, Rabbit LINE Pay, Touch 'n Go eWallet, TrueMoney WalletAlipay+CN, PayPay)</li>
</ul>
</li>
<li>
<p>제공항목</p>
<ul>
<li>[주문 정보] : 상품명, 주문 금액, 통화(화폐), 결제수단</li>
<li>[구매자 정보] : (선택) 이름, 이메일</li>
</ul>
</li>
</ul><br/>
<p><c>현금영수증 서비스</c></p>
<ul>
<li>제공받는 자: <c>국세청</c></li>
<li>제공항목: [현금영수증 발급정보] <c>주민등록번호</c> 혹은 사업자번호, 휴대폰번호, 현금영수증 등록카드번호 (택1)</li>
</ul><br/>
<p>※ 회사는 개인정보를 위의 목적으로 제3자 제공하며, 동의받은 목적 이외의 제3자에게 제공 및 처리하지 않습니다.</p><br/>
<p>2. 개인(신용)정보의 보유 및 이용기간</p>
<p>개인정보는 원칙적으로 <c>개인정보의 제공 목적이 달성되면 지체없이 파기</c>합니다.
단, 다른 법령에 특별한 규정이 있는 경우 관련 법령에서 정하는 기간 동안 보유합니다.</p><br/>
<p>3. 이용자는 회사의 개인(신용)정보 제3자 제공에 대한 동의를 거부할 권리가 있습니다.</p>
<p>다만, 개인(신용)정보의 제3자 제공 동의를 거부할 경우 전자결제서비스의 이용이 제한될 수 있음을 알려드립니다.</p></article>
`;

export const paymentConfirmList = [
  `오래영어 요금제는 월 기본료는 선불 / 초과 사용료는 후불로 매월 1일 합산 결제됩니다.`,
  `카드 자동결제는 1개월 단위, 매월 1일 (영업일 기준)에 이루어집니다.`,
  `자동결제 시 결제 당일을 제외한 이용기간 중 언제든지 자동결제를 해지하실 수 있습니다.`,
  `미사용 상품은 구매 후, 7일 이내 청약철회 가능합니다.`,
  `고객센터를 통한 자동결제 해지 신청은 본인만 가능합니다.`,
];

export const paymentChangeNoticeList = [
  `카드 정보는 전자결제대행사 '토스페이먼츠 주식회사'를 통해 안전하게 관리됩니다.`,
  `자동결제 시 이용기간 중 결제 당일을 제외하고, 언제든지<br />자동결제 해지가 가능합니다.`,
  `기타 자세한 사항은 이용권 안내 페이지를 참고해주세요.`,
  `미사용 상품은 구매 후, 7일 이내 청약철회 가능합니다.`,
];

export const cardRegisterNoticeList = [
  `카드 정보는 결제대행사 '토스페이먼츠 주식회사'를 통해 안전하게 관리됩니다.`,
  `자동결제 시 이용기간 중 결제 당일을 제외하고, 자동결제 해지 가능합니다.`,
  `기타 자세한 사항은 이용권 안내 페이지를 참고해주세요.`,
  `미사용 상품은 구매 후, 7일 이내 청약철회 가능합니다.`,
];

export const app_link = {
  android: 'https://play.google.com/store/apps/details?id=kr.co.longvoca',
  ios: 'https://apps.apple.com/app/id6451292167',
};

//** 스피킹 기준 점수 **//
export const SPEAK_ANSWER_SCORE = 70;
